export enum DraftMessageKind {
  Merchant = "merchant",
  AiCopilot = "ai_copilot",
  AutopilotSend = "autopilot_send",
}
